import {Fragment, useEffect, useState} from 'react';

import {Button} from 'primereact/button';
import {InputNumber} from 'primereact/inputnumber';
import {InputText} from 'primereact/inputtext';
import {Calendar} from 'primereact/calendar';
import {Dropdown} from 'primereact/dropdown';
import {AutoComplete} from 'primereact/autocomplete';
import {RadioButton} from 'primereact/radiobutton';
import classNames from 'classnames';

import {TenantClientService} from '../../danh-muc/khach-hang/TenantClientService';
import {MGateWayService} from '../../lich-su-truyen-nhan/MGateWayService';
import {TaxCodeService} from '../../bao-cao/trang-thai-mst/TaxCodeService';

import {ToastService} from '../../../AppToast';

import {InvoiceField} from './Initial';
import {useDialogCrup} from '../../../shared/hooks/DialogCrup';
import {FormatDisplay} from '../../../shared/format';

export const Input = (props) => {

  const {item, getFormat, patchItem, setting, validators, gridType} = props;

  const {fieldName} = setting;

  const [options, setOptions] = useState([]);
  const [taxCodeStatus, setTaxCodeStatus] = useState(null);

  useEffect(() => {
    switch (fieldName) {
      case InvoiceField.CurrencyCode:

        break;
      default:
      // console.log(fieldName);
    }
  }, [setting]); // eslint-disable-line react-hooks/exhaustive-deps

  const searchTaxCodeTenant = () => {
    const {taxCode, code} = getValue();
    if (taxCode) {
      MGateWayService.searchTaxCode(taxCode).then(data => {
        if (data.buyerLegalName) {
          setValue({
            code: code || '',
            taxCode: data.buyerTaxCode || '',
            name: data.buyerLegalName || '',
            personContact: data.buyerDisplayName || '',
            address: data.buyerAddress || ''
          });
        } else {
          ToastService.error('Không tìm thấy dữ liệu');
        }
      });
    }
  }
  const {render: renderDialogTenantClient, getValue, setValue, create: createTenantClient} = useDialogCrup({
    header: 'Khách hàng',
    dataKey: 'id',
    width: '60rem',
    fields: [
      {field: 'code', header: 'Mã khách hàng', required: true, uppercase: true, InputTextProps: {maxLength: 50}, className: 'md:col-6'},
      {field: 'taxCode', header: 'Mã số thuế', InputTextProps: {maxLength: 14, validator: 'taxCode'}, className: 'md:col-5'},
      {
        type: 'custom', className: 'md:col-1', body: (
          <div className="mt-4">
            <Button icon="pi pi-search" className="p-button-rounded p-button-outlined" onClick={searchTaxCodeTenant}/>
          </div>
        )
      },
      {field: 'name', header: 'Tên đơn vị', InputTextProps: {maxLength: 400}, className: 'md:col-12'},
      {field: 'personContact', header: 'Người mua hàng', InputTextProps: {maxLength: 100}, className: 'md:col-12'},
      {field: 'address', header: 'Địa chỉ', InputTextProps: {maxLength: 400}, className: 'md:col-12'},
      {field: 'email', header: 'Email', type: 'email', InputTextProps: {maxLength: 50}, className: 'md:col-6'},
      {field: 'mobile', header: 'Điện thoại', InputTextProps: {maxLength: 20}, className: 'md:col-6'},
      {field: 'bankAccount', header: 'Số tài khoản', InputTextProps: {maxLength: 30}, className: 'md:col-5'},
      {field: 'bankName', header: 'Tên ngân hàng', InputTextProps: {maxLength: 400}, className: 'md:col-7'}
    ],
    createItem: (item) => {
      return TenantClientService.create(item);
    },
    refreshLazyData: (data) => {
      patchItem(setting.groupTypeCode, fieldName, data);
    }
  });

  const completeMethod = (event) => {
    switch (fieldName) {
      case InvoiceField.BuyerTaxCode:
        TenantClientService.getList({taxCode: event.query, MaxResultCount: 1000}).then(({items}) => {
          setOptions(items);
        });
        break;
      case InvoiceField.BuyerCode:
        TenantClientService.getList({code: event.query, MaxResultCount: 1000}).then(({items}) => {
          setOptions(items);
        });
        break;
      case InvoiceField.BuyerLegalName:
        TenantClientService.getList({name: event.query, MaxResultCount: 1000}).then(({items}) => {
          setOptions(items);
        });
        break;
    }
  }

  const searchTaxCode = () => {
    if (item[fieldName]) {
      MGateWayService.searchTaxCode(item[fieldName]).then(data => {
        if (data) {
          if (data.error) {
            ToastService.error(data.error);
          } else if (data.buyerLegalName) {
            patchItem(setting.groupTypeCode, fieldName, data);
          } else {
            ToastService.error('Không tìm thấy dữ liệu.');
          }
        }
      });
      setTaxCodeStatus(null);
      TaxCodeService.get(item[fieldName]).then(data => {
        if (data?.tthai && data?.ten_tthai && !['00', '02', '04'].includes(data?.tthai)) {
          setTaxCodeStatus(<i>Hóa đơn có thể bị lỗi do MST <b style={{backgroundColor: 'yellow'}}>{item[fieldName]}</b> có trạng thái <span style={{color: 'red'}}>{data?.ten_tthai}</span>.</i>);
        }
      }).catch(() => {
      });
    }
  }

  let required = null;
  if (setting.required) {
    required = <span className="required">*</span>;
  }
  const className = classNames({'p-invalid': (validators && validators[fieldName])});

  const inputProps = {
    value: item[fieldName],
    className,
    disabled: !setting.readOnly
  }

  let _maxLength = setting.maxLength;
  switch (fieldName) {
    case InvoiceField.relatedTemplateCode:
      if (item[InvoiceField.relatedInvoiceType] === 1) {
        _maxLength = 1;
      } else {
        _maxLength = 11;
      }
      break;
    case InvoiceField.relatedInvoiceSerial:
      if (item[InvoiceField.relatedInvoiceType] === 1) {
        _maxLength = 6;
      } else {
        _maxLength = 6;
      }
      break;
  }

  const inputText = <InputText id={fieldName} {...inputProps} onChange={e => patchItem(setting.groupTypeCode, fieldName, e.target.value)} maxLength={_maxLength}/>

  let input;
  switch (fieldName) {
    case InvoiceField.InvoiceSerial:
      if (setting.options) {
        input = <Dropdown {...inputProps} options={setting.options}
                          onChange={e => patchItem(setting.groupTypeCode, fieldName, e.value)}/>
      } else {
        input = inputText;
      }
      break;
    case InvoiceField.CurrencyCode:
      input = <Dropdown {...inputProps} options={setting.options} optionLabel="code"
                        onChange={e => patchItem(setting.groupTypeCode, fieldName, e.value)}/>
      break;
    case InvoiceField.paymentMethod:
    case InvoiceField.relatedInvoiceProperty:
    case InvoiceField.relatedInvoiceType:
    case InvoiceField.vatRateOverRevenue:
      input = <Dropdown {...inputProps} options={setting.options}
                        onChange={e => patchItem(setting.groupTypeCode, fieldName, e.value)}/>
      break;
    case InvoiceField.nonTaxZone:
    case InvoiceField.isDeductionNQ43:
      input = <div className="flex flex-wrap gap-3">
        {setting.options?.map((option, index) => <div key={index} className="flex align-items-center">
          <RadioButton inputId={`${option.value}`} name={fieldName} value={option.value} onChange={e => patchItem(setting.groupTypeCode, fieldName, e.value)} checked={inputProps.value === option.value}/>
          <label htmlFor={`${option.value}`} className="ml-2">{option.label}</label>
        </div>)}
      </div>
      break;
    case InvoiceField.BuyerTaxCode:
      const taxCodeTemplate = (item) => {
        const labels = [];
        if (item.taxCode) {
          labels.push(item.taxCode);
        }
        if (item.name) {
          labels.push(item.name);
        }
        if (item.address) {
          labels.push(item.address);
        }
        return <div style={{width: '50rem', whiteSpace: 'break-spaces'}}>{labels.join(' - ')}</div>
      }
      const onTaxCodeChange = e => {
        if (e.value?.taxCode) {
          const tenantClient = e.value;
          patchItem(setting.groupTypeCode, fieldName, {
            buyerCode: tenantClient.code,
            buyerTaxCode: tenantClient.taxCode,
            buyerLegalName: tenantClient.name,
            buyerAddress: tenantClient.address,
            buyerEmail: tenantClient.email,
            buyerBankAccount: tenantClient.bankAccount,
            buyerBankName: tenantClient.bankName,
            buyerTel: tenantClient.mobile,
            buyerDisplayName: tenantClient.personContact
          });
        } else {
          patchItem(setting.groupTypeCode, fieldName, e.value);
        }
      }
      input = (
        <div className="p-inputgroup">
          <AutoComplete {...inputProps} suggestions={options} completeMethod={completeMethod} field="taxCode" itemTemplate={taxCodeTemplate}
                        onChange={onTaxCodeChange}/>
          <span className="p-inputgroup-addon">
              <i className="pi pi-search" onClick={searchTaxCode}/>
          </span>
        </div>
      )
      break;
    case InvoiceField.BuyerCode:
      const codeTemplate = (item) => {
        const labels = [];
        if (item.code) {
          labels.push(item.code);
        }
        if (item.name) {
          labels.push(item.name);
        }
        if (item.address) {
          labels.push(item.address);
        }
        return <div style={{width: '50rem', whiteSpace: 'break-spaces'}}>{labels.join(' - ')}</div>
      }
      input = (
        <div className="p-inputgroup">
          <AutoComplete {...inputProps} suggestions={options} completeMethod={completeMethod} field="name" itemTemplate={codeTemplate}
                        onChange={e => patchItem(setting.groupTypeCode, fieldName, e.value)}/>
          <span className="p-inputgroup-addon">
              <i className="pi pi-plus" onClick={createTenantClient}/>
          </span>
          {renderDialogTenantClient()}
        </div>
      )
      break;
    case InvoiceField.BuyerLegalName:
      const nameTemplate = (item) => {
        const labels = [];
        if (item.taxCode) {
          labels.push(item.taxCode);
        }
        if (item.name) {
          labels.push(item.name);
        }
        if (item.address) {
          labels.push(item.address);
        }
        return <div style={{width: '50rem', whiteSpace: 'break-spaces'}}>{labels.join(' - ')}</div>
      }
      const onNameChange = e => {
        if (e.value?.taxCode) {
          const tenantClient = e.value;
          patchItem(setting.groupTypeCode, fieldName, {
            buyerCode: tenantClient.code,
            buyerTaxCode: tenantClient.taxCode,
            buyerLegalName: tenantClient.name,
            buyerAddress: tenantClient.address,
            buyerEmail: tenantClient.email,
            buyerBankAccount: tenantClient.bankAccount,
            buyerBankName: tenantClient.bankName,
            buyerTel: tenantClient.mobile,
            buyerDisplayName: tenantClient.personContact
          });
        } else {
          patchItem(setting.groupTypeCode, fieldName, e.value);
        }
      }
      input = <AutoComplete {...inputProps} suggestions={options} completeMethod={completeMethod} field="name" itemTemplate={nameTemplate}
                            onChange={onNameChange}/>
      break;
    default:
      switch (setting.dataType) {
        case 'int32':
          const fractionDigits = getFormat(setting);
          input = <InputNumber locale={FormatDisplay.locales} inputId={fieldName} {...inputProps} onChange={e => patchItem(setting.groupTypeCode, fieldName, e.value)}
                               minFractionDigits={fractionDigits} maxFractionDigits={fractionDigits}/>
          break;
        case 'string':
          input = inputText
          break;
        case 'datetime':
          input = <Calendar id={fieldName} {...inputProps} onChange={e => patchItem(setting.groupTypeCode, fieldName, e.value)} dateFormat="dd/mm/yy"/>
          break;
        default:
          console.log(setting);
      }
  }

  if (gridType === 'percent') {
    return (
      <Fragment>
        {fieldName === InvoiceField.BuyerTaxCode && taxCodeStatus}
        <label htmlFor={fieldName} className={`col-12 mb-2 md:mb-0`} style={{width: setting.lableWidth + '%'}}>{setting.lable}{required}</label>
        <div className={`col-12`} style={{width: setting.controlWidth + '%'}}>
          {input}
          {!!(validators && validators[fieldName]) && <small className="text-red-500">{validators[fieldName]}</small>}
        </div>
      </Fragment>
    );
  } else {
    return (
      <Fragment>
        {fieldName === InvoiceField.BuyerTaxCode && taxCodeStatus}
        <label htmlFor={fieldName} className={`col-12 mb-2 md:col-${setting.lableWidth} md:mb-0`}>{setting.lable}{required}</label>
        <div className={`col-12 md:col-${setting.controlWidth}`}>
          {input}
          {!!(validators && validators[fieldName]) && <small className="text-red-500">{validators[fieldName]}</small>}
        </div>
      </Fragment>
    );
  }

}